import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import EreaceLandingMock from './EreaceLandingMock';
import PrivacyPolicy from './PrivacyPolicy';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<EreaceLandingMock lang="en" />} />
          <Route path="/es" element={<EreaceLandingMock lang="es" />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
